// extracted by mini-css-extract-plugin
export var deleteModal = "_s7-0";